// src/theme/spacing/index.ts
var spacing = {
  0.5: "0.5px",
  1: "1px",
  2: "2px",
  4: "4px",
  6: "6px",
  8: "8px",
  10: "10px",
  12: "12px",
  14: "14px",
  16: "16px",
  20: "20px",
  24: "24px",
  32: "32px",
  40: "40px",
  48: "48px",
  56: "56px",
  64: "64px",
  75: "72px",
  80: "80px"
};
var spacing_default = spacing;

export { spacing_default as default };
